import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { getRelativeTimeValue } from "../utils";
import { RangeTimeValue } from "../types";

export const useAbsoluteDateRange = (initialValue?: RangeTimeValue) => {
  const [absoluteDate, setAbsoluteDate] = useState({
    // start:  initialValue?.start ? dayjs(initialValue.start) : dayjs(),
    start:  dayjs(),
    stop: initialValue?.stop ? dayjs(initialValue.stop) : null,
  });

  const [error, setError] = useState<string | null>(null);

  const updateStart = useCallback((start: dayjs.Dayjs | null) => {
    if (start && start.isValid()) {
      setAbsoluteDate((prev) => ({ ...prev, start }));
    } else if (start === null) {
      setAbsoluteDate((prev) => ({ ...prev, start: dayjs() }));
    }
  }, []);

  const updateStop = useCallback((stop: dayjs.Dayjs | null) => {
    setAbsoluteDate((prev) => ({ ...prev, stop }));
  }, []);

  const reset = useCallback(() => {
    setAbsoluteDate({ start: dayjs(), stop: null });
    setError(null);
  }, []);

  useEffect(() => {
    if (initialValue && getRelativeTimeValue(initialValue) === 'absolute') {
      setAbsoluteDate({
        start: dayjs(initialValue.start),
        stop: initialValue.stop ? dayjs(initialValue.stop) : null
      });
    }
  }, [initialValue?.start, initialValue?.stop]);

  return { absoluteDate, updateStart, updateStop, error, setError, reset };
}
